import { combineReducers } from "@reduxjs/toolkit";

import publicReducers from "../slices/public";

const reducers = combineReducers({
  public: publicReducers,
});

export default reducers;
